import "@/App.css";

/**
 * Tiny loading skeletons for a smoother mobile feel than "Loading…" text.
 * Uses CSS shimmer defined in App.css (.tf-skeleton).
 */

export const SkeletonLine = ({ width = "100%", height = 14, style = {} }) => (
  <div
    className="tf-skeleton"
    style={{ width, height, borderRadius: 6, ...style }}
    aria-hidden="true"
  />
);

export const SkeletonBox = ({ width = "100%", height = 80, radius = 12, style = {} }) => (
  <div
    className="tf-skeleton"
    style={{ width, height, borderRadius: radius, ...style }}
    aria-hidden="true"
  />
);

/** 6 product cards placeholder for the catalog grid */
export const ProductGridSkeleton = ({ count = 6 }) => (
  <div className="tf-product-grid" aria-hidden="true">
    {Array.from({ length: count }).map((_, i) => (
      <div key={`sk-prod-${i}`} className="tf-product-card" style={{ cursor: "default" }}>
        <div className="tf-product-image">
          <SkeletonBox height="100%" radius={0} />
        </div>
        <div className="tf-product-body" style={{ padding: 12 }}>
          <SkeletonLine width="80%" height={13} />
          <SkeletonLine width="50%" height={11} style={{ marginTop: 8 }} />
        </div>
      </div>
    ))}
  </div>
);

/** N rows for list-style pages (chat list, history, problems) */
export const ListSkeleton = ({ rows = 5 }) => (
  <div style={{ display: "flex", flexDirection: "column", gap: 12 }} aria-hidden="true">
    {Array.from({ length: rows }).map((_, i) => (
      <div
        key={`sk-row-${i}`}
        style={{
          display: "flex",
          gap: 12,
          padding: 14,
          borderRadius: 16,
          border: "1px solid var(--tf-border)",
          background: "var(--tf-surface)",
        }}
      >
        <SkeletonBox width={44} height={44} radius={999} />
        <div style={{ flex: 1 }}>
          <SkeletonLine width="70%" height={14} />
          <SkeletonLine width="50%" height={11} style={{ marginTop: 8 }} />
        </div>
      </div>
    ))}
  </div>
);

/** Store card grid used by Dashboard */
export const StoreGridSkeleton = ({ count = 4 }) => (
  <div className="tf-stores-grid" aria-hidden="true">
    {Array.from({ length: count }).map((_, i) => (
      <div key={`sk-store-${i}`} className="tf-store-card" style={{ cursor: "default" }}>
        <div className="tf-store-image">
          <SkeletonBox height="100%" radius={0} />
        </div>
        <div className="tf-store-body">
          <SkeletonLine width="60%" height={16} />
          <SkeletonLine width="40%" height={12} style={{ marginTop: 8 }} />
        </div>
      </div>
    ))}
  </div>
);
